import React, { useState, useRef, useEffect, useContext } from "react";
import { FormattedMessage } from "gatsby-plugin-react-intl";

import ExternalLinks from "../../utils/externalLinks";
import InternalLinks from "../../utils/internalLinks";
import LighboxContext from "../../context/LighboxContext";
import ReactImageVideoLightboxComponent from "../../components/ReactImageVideoLightbox";

import {
  NavButton,
  NavLinks,
  Menu,
  Options,
  LinkGroup,
  OptionsGroup,
  HighlightSection,
  HighlightSectionDescription,
  HighlightSectionIcon,
  CustomLink,
  CustomExternalLink
} from "./styles";

import DiscordLogo from "../../img/logos/discord-logo.svg";

/* eslint-disable */
const BarMenu = ({
  date,
  title,
  number,
  description,
  redirectlink,
  redirectmessage,
  backgroundImage,
}) => {
  const { showVideo, openLightbox } = useContext(LighboxContext);

  const [showProductOptions, setShowProductOptions] = useState(true); //default open
  const [showBuildOptions, setShowBuildOptions] = useState(false);
  const [showDAGTokenOptions, setShowDAGTokenOptions] = useState(false);
  const [showCompanyOptions, setShowCompanyOptions] = useState(false);

  const showProductRef = useRef(null);
  const showCompanyRef = useRef(null);
  const showBuildRef = useRef(null);
  const showDAGTokenRef = useRef(null);
  const windowGlobal = typeof window !== "undefined" && window;

  useEffect(() => {
    if (!windowGlobal) {
      return;
    }
    window.scrollTo(0, 5);
  }, []);

  useEffect(() => {
    if (!windowGlobal) {
      return;
    }

    window.scrollTo(0, 0);

    if (showProductRef.current) {
      showProductRef.current.focus();
    }
  }, [showProductOptions, windowGlobal]);

  useEffect(() => {
    if (!windowGlobal) {
      return;
    }

    window.scrollTo(0, 0);

    if (showBuildRef.current) {
      showBuildRef.current.focus();
    }
  }, [showBuildOptions, windowGlobal]);

  useEffect(() => {
    if (!windowGlobal) {
      return;
    }

    window.scrollTo(0, 0);

    if (showDAGTokenRef.current) {
      showDAGTokenRef.current.focus();
    }
  }, [showDAGTokenOptions, windowGlobal]);

  useEffect(() => {
    if (!windowGlobal) {
      return;
    }

    window.scrollTo(0, 0);

    if (showCompanyRef.current) {
      showCompanyRef.current.focus();
    }
  }, [showCompanyOptions, windowGlobal]);


  return (
    <>
      {openLightbox ? (
        <ReactImageVideoLightboxComponent />
      ) : (
        <Menu>
          <NavLinks>
            <NavButton
              selected={showProductOptions}
              onClick={() => {
                setShowCompanyOptions(false);
                setShowBuildOptions(false);
                setShowDAGTokenOptions(false);
                setShowProductOptions(true);
              }}
            >
              <FormattedMessage id="nav.products" />
            </NavButton>
            <NavButton
              selected={showBuildOptions}
              onClick={() => {
                setShowCompanyOptions(false);
                setShowBuildOptions(true);
                setShowProductOptions(false);
                setShowDAGTokenOptions(false);
              }}
            >
              <FormattedMessage id="nav.build" />
            </NavButton>
            <NavButton
              selected={showDAGTokenOptions}
              onClick={() => {
                setShowCompanyOptions(false);
                setShowBuildOptions(false);
                setShowProductOptions(false);
                setShowDAGTokenOptions(true);
              }}
            >
              <FormattedMessage id="nav.dag" />
            </NavButton>
            <NavButton
              selected={showCompanyOptions}
              onClick={() => {
                setShowCompanyOptions(true);
                setShowBuildOptions(false);
                setShowProductOptions(false);
                setShowDAGTokenOptions(false);
              }}
            >
              <FormattedMessage id="nav.company" />
            </NavButton>
          </NavLinks>
          {showProductOptions && (
            <Options background="primary-darken" offset="82%">
              <OptionsGroup background="primary">
                <LinkGroup>
                  <CustomLink to={InternalLinks.DIGITAL_EVIDENCE}>
                    <FormattedMessage id="nav.digital_evidence" />
                  </CustomLink>
                  <CustomLink to={InternalLinks.DTM}>
                    <FormattedMessage id="nav.dtm" />
                  </CustomLink>
                  <CustomLink to={InternalLinks.FEDERAL}>
                    <FormattedMessage id="nav.federal" />
                  </CustomLink>
                  <CustomLink to={InternalLinks.STARGAZER_WALLET}>
                    <FormattedMessage id="nav.stargazer_wallet" />
                  </CustomLink>
                </LinkGroup>
              </OptionsGroup>
            </Options>
          )}
          {showBuildOptions && (
            <Options background="primary-darken" offset="52.5%">
              <OptionsGroup background="primary">
                <LinkGroup>
                  <CustomLink to={InternalLinks.GET_STARTED}>
                    <FormattedMessage id="nav.get_started" />
                  </CustomLink>
                  <CustomExternalLink href={ExternalLinks.DEVDOCS}>
                    <FormattedMessage id="nav.documentation" />
                  </CustomExternalLink>
                  <CustomLink to={InternalLinks.SNAPSHOT_FEE_CALCULATOR}>
                    <FormattedMessage id="nav.snapshot_fee_calculator" />
                  </CustomLink>
                  <CustomExternalLink href={ExternalLinks.METANOMICS}>
                    <FormattedMessage id="nav.tokenomics" />
                  </CustomExternalLink>
                </LinkGroup>
              </OptionsGroup>
              <OptionsGroup background="primary-darken">
                <HighlightSection>
                  <HighlightSectionIcon>
                    <DiscordLogo />
                  </HighlightSectionIcon>
                  <HighlightSectionDescription>
                    <CustomExternalLink href={ExternalLinks.DEVSDISCORD}>
                      <FormattedMessage id="nav.discord" />
                    </CustomExternalLink>
                    <p>
                      <FormattedMessage id="nav.devs_discord_desc" />
                    </p>
                  </HighlightSectionDescription>
                </HighlightSection>
              </OptionsGroup>
            </Options>
          )}
          {showDAGTokenOptions && (
            <Options background="primary-darken" offset="52.5%">
              <OptionsGroup background="primary">
                <LinkGroup>
                  <CustomLink to={InternalLinks.DAG_TOKEN}>
                    <FormattedMessage id="nav.what_is_dag" />
                  </CustomLink>
                  <CustomLink to={InternalLinks.PACASWAP}>
                    <FormattedMessage id="nav.swap" />
                  </CustomLink>
                  <CustomLink to={InternalLinks.STARGAZER_WALLET}>
                    <FormattedMessage id="nav.wallet" />
                  </CustomLink>
                  <CustomLink to={InternalLinks.DELEGATED_STAKING}>
                    <FormattedMessage id="nav.stake_dag" />
                  </CustomLink>
                  <CustomExternalLink href={ExternalLinks.DAG_EXPLORER}>
                    <FormattedMessage id="nav.explorer" />
                  </CustomExternalLink>
                  <CustomExternalLink href={ExternalLinks.BRIDGE_DAG}>
                    <FormattedMessage id="nav.bridge_dag" />
                  </CustomExternalLink>
                </LinkGroup>
              </OptionsGroup>
            </Options>
          )}
          {showCompanyOptions && (
            <Options background="primary-darken" offset="52.5%">
              <OptionsGroup background="primary">
                <LinkGroup>
                  <CustomLink to={InternalLinks.TEAM}>
                    <FormattedMessage id="nav.team" />
                  </CustomLink>
                  <CustomLink to={InternalLinks.CAREERS}>
                    <FormattedMessage id="nav.now_hiring" />
                  </CustomLink>
                  <CustomLink to={InternalLinks.COMMUNITY}>
                    <FormattedMessage id="nav.join_community" />
                  </CustomLink>
                </LinkGroup>
              </OptionsGroup>
            </Options>
          )}
        </Menu>
      )}
    </>
  );
};

export default BarMenu;
